<template>
    <!-- <div class="row" v-show="showLoader">
       <div class="col-md-4" v-for="(a,i) in 6" :key="i">
            <div style="width: 100%">
                <div class="" style="">
                    <div class="loading"></div>
                    <table style="margin: 0 auto; width: 95%">
                        <tbody>
                            <tr>
                            <td class="td-1"><span></span></td>
                            <td class="td-2"><span></span></td>
                            <td class="td-3"><span></span></td>
                            <td class="td-4"></td>
                            <td class="td-5"><span></span></td>
                            </tr>
                            <tr>
                            <td class="td-1"><span></span></td>
                            <td class="td-2"><span></span></td>
                            <td class="td-3"><span></span></td>
                            <td class="td-4"></td>
                            <td class="td-5"><span></span></td>
                            </tr>
                            <tr>
                        </tbody>
                    </table>
                </div>
            </div>
       </div>
    </div> -->
    <div>
         <table v-show="showLoader" style="margin: 0 auto; width: 95%">
            <tbody>
                <tr>
                <td class="td-1"><span></span></td>
                <td class="td-2"><span></span></td>
                <td class="td-3"><span></span></td>
                <td class="td-4"></td>
                <td class="td-5"><span></span></td>
                </tr>
                <tr>
                <td class="td-1"><span></span></td>
                <td class="td-2"><span></span></td>
                <td class="td-3"><span></span></td>
                <td class="td-4"></td>
                <td class="td-5"><span></span></td>
                </tr>
                <tr>
                <td class="td-1"><span></span></td>
                <td class="td-2"><span></span></td>
                <td class="td-3"><span></span></td>
                <td class="td-4"></td>
                <td class="td-5"><span></span></td>
                </tr>
                <tr>
                <td class="td-1"><span></span></td>
                <td class="td-2"><span></span></td>
                <td class="td-3"><span></span></td>
                <td class="td-4"></td>
                <td class="td-5"><span></span></td>
                </tr>
                <tr>
                <td class="td-1"><span></span></td>
                <td class="td-2"><span></span></td>
                <td class="td-3"><span></span></td>
                <td class="td-4"></td>
                <td class="td-5"><span></span></td>
                </tr>
                <tr>
               
                <tr>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: ['showLoader'],
    data() {
        return {
            pumpCounts: 6
        }
    },
    created() {
    }
 }
</script>